<template>
  <div class="card">
    <div class="card-header">
      <slot name="header" />
    </div>
    <div v-if="showBody" class="card-body">
      <div class="form-group">
        <label for="nachname">Vor- & Nachname<span class="text-danger">*</span></label>
        <input v-model.trim="$v.address.name.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.name.$error }">
      </div>
      <div class="form-group">
        <label for="company">Firma</label>
        <input v-model.trim="$v.address.company.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.company.$error }">
      </div>
      <div class="form-group">
        <label for="city">Stadt<span class="text-danger">*</span></label>
        <input v-model.trim="$v.address.city.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.city.$error }">
      </div>
      <div class="form-group">
        <label for="street">Strasse, Nr.<span class="text-danger">*</span></label>
        <input v-model.trim="$v.address.street.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.street.$error }">
      </div>
      <div class="form-group">
        <label for="phone">Telefonnummer<span class="text-danger">*</span></label>
        <input v-model.trim="$v.address.phone.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.phone.$error }">
      </div>
      <div class="form-group">
        <label for="email">Email<span class="text-danger">*</span></label>
        <input v-model.trim="$v.address.email.$model" type="text" class="form-control" :class="{ 'is-invalid': $v.address.email.$error }">
      </div>
      <div class="text-right">
        <span class="text-muted"><span class="text-danger">*</span> Pflichtangaben</span>
      </div>
    </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  mixins: [validationMixin],
  validations: {
    address: {
      name: { required },
      company: { required },
      city: { required },
      street: { required },
      phone: { required },
      email: { required, email }
    },
    validationGroup: ['address.name', 'address.city']
  },
  props: {
    title: {
      type: String,
      default: null
    },
    address: {
      type: Object,
      default: null
    },
    optional: {
      type: Boolean,
      default: false
    },
    optionalFlag: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    showBody () {
      // eslint-disable-next-line
      return !this.optional || this.optional && this.optionalFlag
    }
  }
}
</script>
